import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { DebounceClickDirective, SwiperDirective } from './directives';
import { MaterialModule } from './modules';
import { FormErrorMessagePipe, MaskPhonePipe, ViewsColorPipe, TimezoneConversionPipe } from './pipes';
import { FilterTextPipe } from './pipes/filter-text.pipe';
import { SelectedFilterNamePipe } from './pipes/selected-filter-name.pipe';
import { S3ImagePipe } from './pipes/s3-image.pipe';

const modules = [CommonModule, FormsModule, ReactiveFormsModule, MaterialModule, RouterModule];
const pipes = [FormErrorMessagePipe, MaskPhonePipe, ViewsColorPipe, TimezoneConversionPipe, FilterTextPipe, SelectedFilterNamePipe, S3ImagePipe];
const directives = [DebounceClickDirective, SwiperDirective];

@NgModule({
	declarations: [...pipes, ...directives],
	imports: [...modules],
	exports: [...modules, ...pipes, ...directives],
})
export class SharedModule {}
